import { useAPI } from "shared/api/hooks";

import * as api from "./api";

export const useUserInfo = () =>
  useAPI<null, api.UserInfo>(api.getUserInfoRequestURI, null);
